import { Patient } from '../../api/fetchAppointments';
import { AP } from '../../pages/Appointments';
import { Patient as DBPatient } from '../../store/types/patient';
import { Data } from '../../pages/PatientInfoComp';
import { Patient as PatientType } from '../../store/types/patient';
import { MHC } from '../../store/types/medicalHistory';

export const SHOW_GOOGLE_REVIEW_KNOW_MORE_DIALOG = 'SHOW_GOOGLE_REVIEW_KNOW_MORE_DIALOG';
export const OPEN_GLOBAL_SEARCH = 'OPEN_GLOBAL_SEARCH';
export const ON_HFR_CREATED_SUCCESSFULLY = 'ON_HFR_CREATED_SUCCESSFULLY';
export const ON_HPR_CREATED_SUCCESSFULLY = 'ON_HPR_CREATED_SUCCESSFULLY';

export interface OnHFRCreatedSuccessfullyEvent {
    type: typeof ON_HFR_CREATED_SUCCESSFULLY;
}

export interface OnHPRCreatedSuccessfullyEvent {
    type: typeof ON_HPR_CREATED_SUCCESSFULLY;
}

export interface ShowGoogleReviewKnowMoreDialogEvent {
    type: typeof SHOW_GOOGLE_REVIEW_KNOW_MORE_DIALOG;
    docid: string;
}

export const UPDATE_PATIENT_PROFILE_AND_RELOAD = 'UPDATE_PATIENT_PROFILE_AND_RELOAD';

export interface UpdatePatientProfileAndReload {
    type: typeof UPDATE_PATIENT_PROFILE_AND_RELOAD;
}

export const EXPORT_ALL_PT = 'EXPORT_ALL_PT';

export interface ExportAllPtEvent {
    type: typeof EXPORT_ALL_PT;
}

export const INIT_MEDICAL_CERTIFICATE = 'INIT_MEDICAL_CERTIFICATE';

export interface InitMedicalCertificateEvent {
    type: typeof INIT_MEDICAL_CERTIFICATE;
    ap: AP;
}

export const OPEN_URL_IN_IFRAME_DIALOG = 'OPEN_URL_IN_IFRAME_DIALOG';

export interface ToggleIframeActionDialogEvent {
    type: typeof OPEN_URL_IN_IFRAME_DIALOG;
    url: string;
}

export const ON_APPT_ACTION = 'ON_APPT_ACTION';

export interface OnApptActionEvent {
    type: typeof ON_APPT_ACTION;
    a: AP;
    cId: string;
    dontAllowStartVisit?: boolean;
    isNotesMode?: boolean;
}

export const ON_REQUEST_MEDICAL_RECORDS = 'ON_REQUEST_MEDICAL_RECORDS';
export const ON_REQUEST_ABHA_CREATION = 'ON_REQUEST_ABHA_CREATION';
export const ON_ADD_ADDRESS = 'ON_ADD_ADDRESS';

export interface RequestMedicalRecordsEvent {
    type: typeof ON_REQUEST_MEDICAL_RECORDS;
    a: AP;
}

export interface RequestCreateAbhaEvent {
    type: typeof ON_REQUEST_ABHA_CREATION;
    a: AP;
}

export interface AddAddressEvent {
    type: typeof ON_ADD_ADDRESS;
    a: AP;
}

export const BILLING_POPUP = 'BILLING_POPUP';

export type BILLING_SOURCE =
    | 'apt-queue'
    | 'new-patients'
    | 'all-patients'
    | 'prescription'
    | 'billing-queue'
    | 'pt-details';

export interface BillPopupEvent {
    type: typeof BILLING_POPUP;
    data: {
        aid?: string | null;
        patient: Patient;
        docid?: string | null;
        uhid?: string | null;
        clinicId: string;
        source: BILLING_SOURCE;
        aptDate?: string;
    };
}

export const REQUEST_PAYMENT = 'REQUEST_PAYMENT';

export interface ElixirRequestPaymentEvent {
    type: typeof REQUEST_PAYMENT;
    data: {
        aid?: string | null;
        patient: Patient;
        uhid?: string | null;
        clinicId: string;
        source: 'request-payment';
        aptDate?: string;
    };
}

export const NEW_PT_FORM_DATA = 'NEW_PT_FORM_DATA';
export const NEW_PT_FORM_DATA_AS_SELECTED = 'NEW_PT_FORM_DATA_AS_SELECTED';

export interface NewPtFormDataChange {
    type: typeof NEW_PT_FORM_DATA;
    data: Data;
}

export interface NewPtFormDataASSelected {
    type: typeof NEW_PT_FORM_DATA_AS_SELECTED;
    data?: DBPatient;
}

export const ADD_NEW_PT_APPT = 'ADD_NEW_PT_APPT';
export interface AddNewPatientEvent {
    type: typeof ADD_NEW_PT_APPT;
    data?: PatientType;
}

export const ADD_NEW_MODAL_CLOSE = 'ADD_NEW_MODAL_CLOSE';

export interface AddNewPatientModalCloseEvent {
    type: typeof ADD_NEW_MODAL_CLOSE;
}

export const DR_SWITCH_EVENT = 'DR_SWITCH_EVENT';

export interface DrSwitchEvent {
    type: typeof DR_SWITCH_EVENT;
}

export const ON_REFER_PATIENT = 'ON_REFER_PATIENT';

export interface ReferPatientEvent {
    type: typeof ON_REFER_PATIENT;
    a: AP;
}

export const ON_SHOW_SA = 'ON_SHOW_SA';

export interface OnShowSAtEvent {
    type: typeof ON_SHOW_SA;
    a?: AP;
    sa_id?: string;
    sa_ids?: string[];
}

export const ON_CREATE_TEMPLATE = 'ON_CREATE_TEMPLATE';

export interface OnCreateTemplateEvent {
    type: typeof ON_CREATE_TEMPLATE;
    a: AP;
}

export const ON_ORDER_MEDICINE = 'ON_ORDER_MEDICINE';
export const ON_BOOK_LAB_TEST = 'ON_BOOK_LAB_TEST';

export interface OnOrderMedicineEvent {
    type: typeof ON_ORDER_MEDICINE;
    a: AP;
}

export interface OnBookLabTestEvent {
    type: typeof ON_BOOK_LAB_TEST;
    a: AP;
}

export const ON_ENTER_VITALS = 'ON_ENTER_VITALS';

export interface OnEnterVitalsEvent {
    type: typeof ON_ENTER_VITALS;
    a: AP;
}

export const ON_ADD_VACCINATION = 'ON_ADD_VACCINATION';

export interface OnAddVaccination {
    type: typeof ON_ADD_VACCINATION;
    a: AP;
}

export const ON_OPEN_TREATMENT_PLAN = 'ON_OPEN_TREATMENT_PLAN';

export interface OnOpenTreatmentPlanEvent {
    type: typeof ON_OPEN_TREATMENT_PLAN;
    a: AP;
}

export const ON_OPEN_ADMIT_PATIENT_DRAWER = 'ON_OPEN_ADMIT_PATIENT_DRAWER';

export interface OnOpenAdmitPatientDrawerEvent {
    type: typeof ON_OPEN_ADMIT_PATIENT_DRAWER;
    a: AP;
}

export const ON_CLOSE_BILLING_POPUP = 'CLOSE_BILLING_POPUP';

export interface OnCloseBillingPopupEvent {
    type: typeof ON_CLOSE_BILLING_POPUP;
}

export const ON_EDIT_PATIENT = 'ON_EDIT_PATIENT';

export interface OnEditPatientEvent {
    type: typeof ON_EDIT_PATIENT;
    a: AP;
}

export const ON_ADD_PT = 'add-new-patient';

export interface OnAddPatientEvent {
    type: typeof ON_ADD_PT;
    a: AP;
    docid?: string;
}

export const ON_MR_UPLOAD = 'ON_MR_UPLOAD';

export interface OnMrUploadEvent {
    type: typeof ON_MR_UPLOAD;
    ptOid: string;
}

export const CREATE_ABHA = 'CREATE_ABHA';

export interface OnCreateAbhaEvent {
    type: typeof CREATE_ABHA;
    a: AP;
    docid: string;
}

export const OPEN_TRIAL_PERSUASION_POPUP = 'OPEN_TRIAL_PERSUASION_POPUP';

export interface OpenTrialPersuasionPopup {
    type: typeof OPEN_TRIAL_PERSUASION_POPUP;
}

export interface OpenGlobalSearch {
    type: typeof OPEN_GLOBAL_SEARCH;
}

export const PATIENT_ABHA_CREATE = 'PATIENT_ABHA_CREATE';
export const ON_CLOSE_ABHA_CREATION_POPUP = 'ON_CLOSE_ABHA_CREATION_POPUP';
export const ON_ABHA_LINK_POP_UP_CLOSE = 'ON_ABHA_LINK_POP_UP_CLOSE';
export const DEEPCHAT_MEDCERT_COPY = 'CHAT_MEDCERT_COPY';
export interface NewPtFormDataChange {
    type: typeof NEW_PT_FORM_DATA;
    data: Data;
}

export interface NewPtFormDataASSelected {
    type: typeof NEW_PT_FORM_DATA_AS_SELECTED;
    data?: DBPatient;
}

export interface PatientAbhaCreate {
    type: typeof PATIENT_ABHA_CREATE;
}
export interface onCloseAbhaCreationPopupEvent {
    type: typeof ON_CLOSE_ABHA_CREATION_POPUP;
}

export const SHOW_TRIAL_PERSUASION_BANNER = 'SHOW_TRIAL_PERSUASION_BANNER';

export interface ShowTrialPersuasionBanner {
    type: typeof SHOW_TRIAL_PERSUASION_BANNER;
}

export const HPR_HFR_ONBOARDING = 'HPR_HFR_ONBOARDING';

export interface HprHfrOnboarding {
    type: typeof HPR_HFR_ONBOARDING;
}

export interface onAbhaLinkPopUpClose {
    type: typeof ON_ABHA_LINK_POP_UP_CLOSE;
}

export interface ChatMedCertCopyEvent {
    type: typeof DEEPCHAT_MEDCERT_COPY;
    message: string;
}

export type Events =
    | ShowGoogleReviewKnowMoreDialogEvent
    | UpdatePatientProfileAndReload
    | InitMedicalCertificateEvent
    | ToggleIframeActionDialogEvent
    | OnApptActionEvent
    | ExportAllPtEvent
    | ReferPatientEvent
    | OnShowSAtEvent
    | OnCreateTemplateEvent
    | OnOrderMedicineEvent
    | OnBookLabTestEvent
    | OnEnterVitalsEvent
    | OnOpenTreatmentPlanEvent
    | OnOpenAdmitPatientDrawerEvent
    | OnCloseBillingPopupEvent
    | RequestMedicalRecordsEvent
    | RequestCreateAbhaEvent
    | AddAddressEvent
    | OnEditPatientEvent
    | OnCreateAbhaEvent
    | OnAddPatientEvent
    | OpenGlobalSearch
    | OnMrUploadEvent
    | onCloseAbhaCreationPopupEvent
    | OnHPRCreatedSuccessfullyEvent
    | OnHFRCreatedSuccessfullyEvent
    | onAbhaLinkPopUpClose
    | ChatMedCertCopyEvent
    | OnAddVaccination;

export const REFRESH_APPT = 'REFRESH_APPT';
export const DESTROY_CONTAINER = 'DESTROY_CONTAINER';
export const LINK_ABHA_FLOW_V2 = 'LINK_ABHA';
export const ADD_MH_QUEUE = 'ADD_MH_QUEUE';
export const CLOSE_MH_POP = 'CLOSE_MH_POP';
export const SHOW_QUESTIONNAIRE_LIST = 'SHOW_QUESTIONNAIRE_LIST';

export interface RefreshApptEvent {
    type: typeof REFRESH_APPT;
}

export interface DestroyContainerEvent {
    type: typeof DESTROY_CONTAINER;
    containerId: string;
}

export interface LinkAbhaFLow {
    type: typeof LINK_ABHA_FLOW_V2;
    data: DBPatient;
}

export interface ADDMH {
    type: typeof ADD_MH_QUEUE;
    data?: MHC;
}

export interface CloseMHPop {
    type: typeof CLOSE_MH_POP;
}

export interface ShowQuestionnaireList {
    type: typeof SHOW_QUESTIONNAIRE_LIST;
    data: {
        apt: {
            aid: string;
            patient: {
                id: string;
                gen: string;
                dob?: string;
            };
        };
    };
}

export type OutGoingEvents =
    | RefreshApptEvent
    | DestroyContainerEvent
    | BillPopupEvent
    | DrSwitchEvent
    | ElixirRequestPaymentEvent
    | NewPtFormDataChange
    | NewPtFormDataASSelected
    | AddNewPatientEvent
    | AddNewPatientModalCloseEvent
    | OpenTrialPersuasionPopup
    | PatientAbhaCreate
    | ShowTrialPersuasionBanner
    | HprHfrOnboarding
    | LinkAbhaFLow
    | ADDMH
    | CloseMHPop
    | ShowQuestionnaireList;
